const color = {
    pureTeal: '#055A85',
    liveRed: '#D0011B',
    sunLight: '#FCF0E1',
    deepSky: '#02293C',
    disabled: '#7E8A90',
    link: '#F7C98C',
    white: '#FFFFFF',
    black: '#000000',
    bodyGrey: '#595959',
    faceGrey: '#2D2C2C'
};

const fontSize = {
    extraSmall: '8px',
    verySmall: '12px',
    small: '16px',
    big: '20px',
    veryBig: '24px',
    extraBig: '28px',
    huge: '32px',
    veryHuge: '36px',
    extraHuge: '40px',
    massive: '44px',
    veryMassive: '48px',
    extraMassive: '52px',
    enormous: '56px',
    veryEnormous: '60px',
    extraEnormous: '64px',
    insane: '68px',
    veryInstane: '72px',
    extraInsane: '76px',
    gaia: '80px',
    veryGaia: '84px',
    extraGaia: '88px'
};

const padding = {
    tiny: '2px',
    // Increments of 4
    extraSmall: '4px',
    verySmall: '8px',
    small: '12px',
    // Incremenets of 8
    big : '20px',
    veryBig : '28px',
    extraBig : '36px',
    // Increments of 12
    huge: '52px',
    veryHuge: '64px',
    extraHuge: '76px',
    // Incremenets of 16
    massive: '92px',
    veryMassive: '108px',
    extraMassive: '124px',
    // Increment of 20
    enourmous: '100px',
    veryEnormous: '120px',
    extraEnormous: '140px',
    // Increment of 40
    insane: '160px',
    veryInsane: '200px',
    extraInsane: '240px'

};

const fontFamily = {
    bebas: 'bebas_neueregular',
    bilbo: 'bilboregular',
    opensanslight: 'open_sanslight',
    opensansregular: 'open_sansregular',
    thermal: 'thermalregular'
};

const boxShadow = {
    dark: '0px 2px 4px ' + color.black,
    darkButton: '0px 0px 3px' + color.black,
    darkButtonBig: '0px 1px 5px' + color.black

}

export { color, fontSize, fontFamily, padding, boxShadow };